import { render, staticRenderFns } from "./AssignCampusManagementNetworkModal.vue?vue&type=template&id=273374d6&scoped=true&"
import script from "./AssignCampusManagementNetworkModal.vue?vue&type=script&lang=ts&"
export * from "./AssignCampusManagementNetworkModal.vue?vue&type=script&lang=ts&"
import style0 from "./AssignCampusManagementNetworkModal.vue?vue&type=style&index=0&id=273374d6&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273374d6",
  null
  
)

export default component.exports